import { storage, db } from './firebase';
import { Base64 } from 'js-base64';

const storageRef = storage.ref();

// upload user avatar
export const uploadDoc = (user, file) => storageRef.child(`users/${user.uid}/avatar.jpg`)
  .put(file)
  .then((snapshot) => {
    snapshot.ref.getDownloadURL()
      .then((url) => {
        user.updateProfile({
          photoURL: url
        }).then(() => {
          db.ref().update({
            [`users/${Base64.encode(user.email)}/photoUri`]: url
          });
        });
      });
  });

export const uploadProjectDoc = (documentId, file) => {
  storageRef.child(`documents/${documentId}/${file.name}`)
    .put(file)
    .then((snapshot) => {
      snapshot.ref.getDownloadURL()
        .then((url) => {
          db.ref().update({
            [`documents/${documentId}/docUrl`]: url,
          })
        })
    })
}

export const uploadProjectPicture = (projectId, file) => {
  storageRef.child(`projects/${projectId}/${file.name}`)
    .put(file)
    .then((snapshot) => {
      snapshot.ref.getDownloadURL()
        .then((url) => {
          db.ref().update({
            [`projects/${projectId}/projectImage`]: url
          })
        })
    })
}

export const createEmptyLogo = () => db.ref().child('logo').push().key;

export const uploadLogoPicture = (email, file) => {
  const encodedEmail = window.btoa(email)
  const logoId = createEmptyLogo();
  storageRef.child(`logo/${logoId}/${file.name}`)
    .put(file)
    .then((snapshot) => {
      snapshot.ref.getDownloadURL()
        .then((url) => {
          return db.ref().update({
            [`logo/${logoId}/image`]: url
          })
        })
    })
}

export const uploadPersonaDocument = (documentId, file, subTaskId, cycleId) => {
  return storageRef.child(`documents/${documentId}/${file.name}`)
    .put(file)
    .then((snapshot) => {
      snapshot.ref.getDownloadURL()
        .then((url) => {
          return db.ref().update({
            [`documents/${documentId}/docUrl`]: url,
            [`subTasks/${subTaskId}/docUrl`]: url,
            [`subTasks/${subTaskId}/finished`]: true,
            [`subTasks/${subTaskId}/finishedDate`]: (new Date()).getTime(),
            [`subTasks/${subTaskId}/docName`]: file.name,
            [`subTasks/${subTaskId}/document`]: documentId,
            [`subTasks/${subTaskId}/cycle`]: cycleId,
          })
        })
    });
}

// download doc url
export const downloadDocURL = refPath => storageRef.child(refPath)
  .getDownloadURL()
  .then(url => url);




// WEBPACK FOOTER //
// ./src/firebase/storage.js